import React, { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { useFetchAllTypeContainer } from "../../../../../hooks/guide/useFetchAllTypeContainer";
import { TypeContainer } from "../../../../../types/api/guide/typeСontainer.types";
import { typeContainerService } from "../../../../../services/guide/typeContainer-service";
import { ContainerTypesAddModal } from "../../ui/EntityModal/ContainerTypesAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface ContainerTypesTableProps {
    title: string;
}

export const ContainerTypesTable = ({ title }: ContainerTypesTableProps) => {
    const { data: typeContainers, refetch } = useFetchAllTypeContainer();
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [toDelete, setToDelete] = useState<TypeContainer | null>(null);

    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id?: string }>({
        isOpen: false,
        id: undefined,
    });

    const handleDelete = async (id: string) => {
        try {
            await typeContainerService.delete(id);
            showSuccess("Успешное удаление")
            refetch();
        } catch (e) {
            showError(e.response.data);
            console.log("Ошибка при удалении типа контейнера");
        }
    };

    return (
        <>
            <SimpleTable<TypeContainer>
                title={title}
                columns={[
                    { key: "name", title: "Название" },
                    { key: "volume", title: "Объём" },
                ]}
                data={typeContainers}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, id: row.id }),
                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: undefined })}
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить тип контейнера?"
                description={toDelete ? `Будет удалён: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {openModal.isOpen && (
                <ContainerTypesAddModal
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: undefined })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>

    );
};
